import axios from 'axios'
import { Toast } from 'vant'
import store from '../store'
import { isFangCheBaoApp, isIOS, isAndroid } from '@/utils/index'
import { isMiniProgramNew } from '@/globalFun'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL, // 基础api
  timeout: 2000000, // 请求超时时间
})

// request拦截器
service.interceptors.request.use(
  (config) => {
    // loading 处理
    if (config.showLoading) {
      store.commit('showPageLoading')
    }
    // App版本号
    config.headers.ha_app_version = hcApp.getAppVersion() || '1.0.0'

    // 时间戳s
    config.headers.ha_timestamp = new Date().getTime()

    let channel = 3000805 // 默认为h5渠道
    if (hcApp.isHCIOSApp()) {
      if (navigator.userAgent.includes('inner')) {
        channel = 3000809
      } else {
        channel = 3000801
      }
    } else if (hcApp.isHCAndroidApp()) {
      if (navigator.userAgent.includes('inner')) {
        channel = 3000810
      } else {
        channel = 3000802
      }
    } else if (isMiniProgramNew()) {
      channel = 3000803
    } else if (isFangCheBaoApp()) {
      if (isIOS()) {
        channel = 3000811
      } else {
        channel = 3000812
      }
    }
    // 渠道号
    config.headers.ha_channel_code = channel

    // 语言
    config.headers.ha_language = 'zh'

    if (store.state.userInfo) {
      const userInfo = store.state.userInfo
      // 登陆token
      if (!config.headers.ha_acp_token) {
        config.headers.ha_acp_token = userInfo.acpToken
      }
      if (!config.headers.ha_gk_token) {
        config.headers.ha_gk_token = userInfo.gkToken
      }
    }
    return config
  },
  (error) => {
    Promise.reject(error)
  }
)

// respone拦截器
service.interceptors.response.use(
  async (response) => {
    // 隐藏loading
    if (response.config.showLoading) {
      store.commit('hidePageLoading')
    }
    const data = response.data
    if (data.respCode === '0') {
      return data.result
    } else if (data.subCode?.includes('611')) {
      // 发短信前的图形验证码相关接口的错误，需要原样返回
      return data
    } else {
      Toast(data?.subCodeMsg?.substring(0, 300) || data.msg?.substring(0, 300) || '未知异常')
      store.commit('hidePageLoading')
      return Promise.reject(data)
    }
  },
  async (error) => {
    // 隐藏loading
    store.commit('hidePageLoading')
    console.error('请求报错:', error)
    Toast('服务繁忙，请稍后重试！')
    return Promise.reject(error)
  }
)

export default function request(options) {
  return service(options)
}
